import {useState, useEffect} from "react";
import {getConcept} from "@/studio/utils/sanity-utils";

import styles from "@/components/content/ContentConcept.module.css"
import {motion} from "framer-motion";

function ContentConcept({children, conceptRef, conceptType}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [conceptData, setConceptData] = useState(null);

  useEffect(() => {
    if (modalIsOpen && conceptData === null) {
      fetchConcept(conceptRef);
    }
  }, [modalIsOpen]);


  useEffect(() => {
    const bodyClasses = document.body.classList;
    if (modalIsOpen) {
      bodyClasses.add("modalOpen");
    } else {
      bodyClasses.remove("modalOpen");
    }
    return () => {
      bodyClasses.remove("modalOpen");
    };
  }, [modalIsOpen]);

  // fetch the concept information
  const fetchConcept = async (conceptRef) => {
    try {
      const concept = await getConcept(conceptRef);
      setConceptData(concept);
    } catch (err) {
      console.error(err);
    }
  }

  // handle the click event
  const handleClick = (e) => {
    e.preventDefault();
    setModalIsOpen(!modalIsOpen);
  }

  const variants = {
    hidden: {opacity: 0, y: '5%'},
    visible: (i) => ({opacity: 1, y: 0, transition: {duration: 0.5, delay: i * 0.1}}),
  };

  const className = conceptType === 'pill' ? styles.conceptPill : styles.conceptBtn;

  return (
    <>
    <span className={className} onClick={handleClick}>
      {children}
    </span>
      {modalIsOpen && conceptData && (
        <div className={styles.modal}>

          <motion.div
            className={styles.modalContent}
            initial="hidden"
            animate="visible"
            variants={variants}>
            <div className={styles.modalHeader}>
              <motion.div
                initial="hidden"
                animate="visible"
                variants={variants}
                custom={1}
              >
                {conceptData.title}
              </motion.div>
              <button
                className={styles.closeButton}
                onClick={() => setModalIsOpen(false)}>
                ✕
              </button>
            </div>
            <div className={styles.modalBody}>
              <motion.div
                initial="hidden"
                animate="visible"
                variants={variants}
                custom={2}>
                {conceptData.description}
              </motion.div>
            </div>
            <div className={styles.modalFooter}></div>
          </motion.div>
        </div>
      )}
    </>
  )
}

export default ContentConcept;
